import { Deserialize, Serialize } from 'cerialize'
import BaseService from './BaseService'
import ErrorService from './ErrorService'
import ServiceConfig from '../config/ServiceConfig'
import StorageConfig from '../config/StorageConfig'
import { saveAs } from 'file-saver'

export default class HttpService extends BaseService {
  static api = ''

  static entity = ''

  constructor(api = '', entity = '', options = {}, http = null) {
    super(options)
    this.api = api
    this.entity = entity
    this.http = http || ServiceConfig
  }

  static build(options) {
    return new this(this.api, this.entity, options)
  }

  static async setHeader() {
    ServiceConfig.defaults.headers.common['Authorization'] = `Bearer ${StorageConfig.getToken()}`
    ServiceConfig.defaults.headers.common['Content-Type'] = 'application/json'
    ServiceConfig.defaults.headers.common.Accept = 'application/json'
  }

  static setHeaderEms() {
    ServiceConfig.defaults.headers.common['client-id'] = 'plnmobile'
    ServiceConfig.defaults.headers.common['signature'] =
      '00c42ff22fff8217d2f4106d87ab236c0f4e40401897ba32b46ad4c3a61d60f3'
    ServiceConfig.defaults.headers.common['timestamp'] = Date.now()
    ServiceConfig.defaults.headers.common['Content-Type'] = 'application/json'
    ServiceConfig.defaults.headers.common.Accept = 'application/json'
  }

  static removeHeader() {
    ServiceConfig.defaults.headers.common = {}
  }

  // ADD FUNGSI API
    async postLogin(data, url = '') {
        const headers = {headers: {'Content-Type': 'application/json'}}
        const api = url === '' ? this.api : url

        return this.http
            .post(api, data, headers)
            .then(this.constructor.then)
            .catch(e => {
                if (e instanceof ErrorService) {
                    e.showError()
                } else {
                    const alert = new ErrorService(e)
                    alert.showError()
                }
            })
    }

  get(param = {}, url = '') {
    const api = url === '' ? this.api : url

    return this.http
      .get(api, { params: param, data: {} })
      .then(this.constructor.then)
      .catch(e => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

    downloadExcel(param = {}, url = '') {
        const api = url === '' ? this.api : url

        return this.http
            .get(api, {
                params: param,
                responseType: 'blob',
                headers: {
                    'Authorization': `Bearer ${StorageConfig.getToken()}`,
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }
            })
            .then(response => {
                let filename = 'download.xlsx'
                const contentDisposition = response.headers['content-disposition']
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="(.+?)"/)
                    if (match && match[1]) {
                        filename = decodeURIComponent(match[1])
                    }
                }

                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                })

                saveAs(blob, filename)
            })
            .catch(e => {
                if (e instanceof ErrorService) {
                    e.showError()
                } else {
                    const alert = new ErrorService(e)
                    alert.showError()
                }
            })
    }

  downloadPdf(param = {}, url = '') {
    const headers = {
      headers: { 'Content-Type': 'application/octet-stream ' },
    }
    const api = url === '' ? this.api : url
    return this.http
      .get(api, { responseType: 'blob' }, { params: param }, headers)
      .then(this.constructor.then)
      .catch(e => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  post(data, url = '', param = {}) {
    const api = url === '' ? this.api : url
    const deserializeData = Deserialize(data, this.entity)

    return this.http
      .post(api, Serialize(deserializeData), { params: param })
      .then(this.constructor.then)
        .catch(e => {
            const err = e instanceof ErrorService ? e : new ErrorService(e)
            err.showError()
            throw err
        })
  }

  put(data, url = '') {
    const api = url === '' ? this.api : url
    const deserializeData = Deserialize(data, this.entity)

    return this.http
      .put(api, Serialize(deserializeData))
      .then(this.constructor.then)
      .catch(e => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  patch(data, url = '') {
    const api = url === '' ? this.api : url
    const deserializeData = Deserialize(data, this.entity)

    return this.http
      .patch(api, Serialize(deserializeData))
      .then(this.constructor.then)
      .catch(e => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  deleteV2(param = {}, url = '') {
    const api = url === '' ? this.api : url

    return this.http
      .delete(api, { params: param })
      .then(this.constructor.then)
      .catch(e => {
          if (e instanceof ErrorService) {
              e.showError()
          } else {
              const alert = new ErrorService(e)
              alert.showError()
          }
      })
  }

    uploadData(data, url = '') {
    const headers = { headers: { 'Content-Type': 'multipart/form-data' } }
    const api = url === '' ? this.api : url

    return this.http
      .post(api, data, headers)
      .then(this.constructor.then)
      .catch(e => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  uploadDataPut(data, url = '') {
    const headers = { headers: { 'Content-Type': 'multipart/form-data' } }
    const api = url === '' ? this.api : url

    return this.http
      .put(api, data, headers)
      .then(this.constructor.then)
      .catch(e => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

}
